import type { Span } from '@opentelemetry/api'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'

import { SERVICE_NAME } from './constants'
import { INSTRUMENTATIONS } from './instrumentations'
import type { BrowserSDK } from './types'

const appEnvironment: string = __ENVIRONMENT__ || 'production'

const OTEL_TRACES_ENDPOINT =
  appEnvironment === 'production'
    ? 'https://telemetry.appewa.com/api/v1/traces'
    : 'https://telemetry.dev.appewa.com/api/v1/traces'

export const OTLBrowserSDK: BrowserSDK = {
  tracer: null,

  init: function (options) {
    const instrumentations = INSTRUMENTATIONS.filter(
      ({ confKey }) => options?.instrumentations?.[confKey]
    ).map(({ Instrument }) => new Instrument({ enabled: true, ...options }))

    const { application, version, environment, customerId } = options

    const tracerProvider = new WebTracerProvider({
      resource: resourceFromAttributes({
        [ATTR_SERVICE_NAME]: SERVICE_NAME
      }),

      spanProcessors: [
        {
          forceFlush: () => Promise.resolve(),
          onEnd: () => {},
          shutdown: () => Promise.resolve(),
          onStart: (span: Span) => {
            span.setAttribute('application', application)
            span.setAttribute('version', version)
            span.setAttribute('environment', environment)
            span.setAttribute('ewa.customer-id', customerId)
          }
        },

        new BatchSpanProcessor(
          new OTLPTraceExporter({
            url: OTEL_TRACES_ENDPOINT
          }),
          {
            maxQueueSize: 10
          }
        )
      ]
    })

    tracerProvider.register({
      contextManager: new ZoneContextManager()
    })

    registerInstrumentations({
      tracerProvider,
      instrumentations
    })

    this.tracer = tracerProvider.getTracer(SERVICE_NAME)
  }
}
